// Zoom circle animation component
const ZoomCircleAnimation = () => {
    // Getting motion
    const { animate, inView } = Motion;

    // Animation
    const animation = (element) => {
        animate(
            element,
            {
                clipPath: ["circle(10%)", "circle(100%)"]
            },
            {
                ease: "circleInOut",
                duration: 1.5,
            }
        );

        //return () => animate(element, { clipPath: "circle(10%)" })
    };

    if (window.innerWidth > 1199.98) { 
        // On scroll
        inView(".zoomCircle", animation);
    }
};

// Export component
export default ZoomCircleAnimation;